/**
 * Space kept clear at the bottom of the page for the Zoho SalesIQ support
 * bubble, which is fixed to the bottom-right corner above everything else.
 * The bubble is about 64px with a 20px margin; this leaves room for it plus
 * a little air, so the last row of a page (Create Case, Generate document)
 * and our own bottom-right progress panel sit above it (ZLAYT-1418).
 */
export const SUPPORT_WIDGET_CLEARANCE = 104;

/**
 * Space kept clear to the right of a page's last action row for the same
 * bubble: about 55px wide, 10px from the window edge, plus a little air.
 * Create Case is the last thing on its page, so at 1440x900 it sat under the
 * bubble until the user scrolled (ZLAYT-1450).
 */
export const SUPPORT_WIDGET_SIDE_CLEARANCE = 72;
